(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.messages = Array.from(this.querySelectorAll('.announcement-bar__message'));
      this.index = this.messages.findIndex((message) => !message.hidden);
      if (this.index < 0) this.index = 0;
      this.messages.forEach((message, i) => {
        message.hidden = i !== this.index;
        message.classList.toggle('is-active', i === this.index);
      });

      this.prevButton = this.querySelector('.announcement-bar__nav--prev');
      this.nextButton = this.querySelector('.announcement-bar__nav--next');
      this.prevButton?.addEventListener('click', () => this.step(-1));
      this.nextButton?.addEventListener('click', () => this.step(1));

      // Autoplay runs only while nothing asks it to pause: pointer hover,
      // keyboard focus inside, a hidden tab, the shopper's pause button, or
      // a message block selected in the theme editor.
      this.autoplayMs = Number(this.dataset.autoplayMs);
      this.pauseReasons = new Set();
      if (document.hidden) this.pauseReasons.add('hidden');

      this.toggleButton = this.querySelector('[data-autoplay-toggle]');
      this.toggleButton?.addEventListener('click', () => {
        if (this.pauseReasons.has('user')) {
          this.pauseReasons.delete('user');
        } else {
          this.pauseReasons.add('user');
        }
        this.updateToggle();
        this.updateAutoplay();
      });

      this.addEventListener('pointerenter', () => this.pause('hover'));
      this.addEventListener('pointerleave', () => this.resume('hover'));
      this.addEventListener('focusin', () => this.pause('focus'));
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.resume('focus');
      });

      this.onVisibilityChange = () => {
        if (document.hidden) {
          this.pause('hidden');
        } else {
          this.resume('hidden');
        }
      };
      this.onBlockSelect = (event) => {
        const index = this.messages.indexOf(event.target);
        if (index < 0) return;
        this.show(index);
        this.pause('editor');
      };
      this.onBlockDeselect = (event) => {
        if (this.messages.includes(event.target)) this.resume('editor');
      };
      this.onSectionUnload = (event) => {
        if (event.target.contains(this)) this.stopAutoplay();
      };

      document.addEventListener('visibilitychange', this.onVisibilityChange);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      document.addEventListener('shopify:section:unload', this.onSectionUnload);

      this.updateAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      document.removeEventListener('shopify:section:unload', this.onSectionUnload);
    }

    pause(reason) {
      this.pauseReasons.add(reason);
      this.updateAutoplay();
    }

    resume(reason) {
      this.pauseReasons.delete(reason);
      this.updateAutoplay();
    }

    updateAutoplay() {
      const shouldRun = this.autoplayMs > 0 && this.messages.length > 1 && this.pauseReasons.size === 0;
      if (shouldRun && !this.timer) {
        this.timer = setInterval(() => this.step(1), this.autoplayMs);
      } else if (!shouldRun) {
        this.stopAutoplay();
      }
    }

    stopAutoplay() {
      clearInterval(this.timer);
      this.timer = null;
    }

    updateToggle() {
      if (!this.toggleButton) return;
      const paused = this.pauseReasons.has('user');
      this.classList.toggle('is-user-paused', paused);
      this.toggleButton.setAttribute(
        'aria-label',
        paused ? this.toggleButton.dataset.labelPlay : this.toggleButton.dataset.labelPause
      );
    }

    // Jumps straight to a message without the slide (theme editor selection).
    show(index) {
      this.index = index;
      this.animating = false;
      this.messages.forEach((message, i) => {
        message.classList.remove('is-prev', 'is-next');
        message.classList.toggle('is-active', i === index);
        message.hidden = i !== index;
      });
    }

    // Slides the outgoing message out one side while the incoming message
    // slides in from the other, both absolutely stacked in the same box
    // (see .announcement-bar__message's position: absolute; inset: 0).
    // The incoming message starts hidden (display: none), so its
    // off-screen position has to be committed via a forced reflow before
    // switching to is-active, or the two style changes coalesce into one
    // and there's nothing for the transition to animate between.
    step(delta) {
      if (this.messages.length < 2 || this.animating) return;

      const outgoing = this.messages[this.index];
      this.index = (this.index + delta + this.messages.length) % this.messages.length;
      const incoming = this.messages[this.index];

      const outClass = delta > 0 ? 'is-prev' : 'is-next';
      const inClass = delta > 0 ? 'is-next' : 'is-prev';

      this.animating = true;
      incoming.classList.remove('is-active', 'is-prev', 'is-next');
      incoming.hidden = false;
      incoming.classList.add(inClass);
      void incoming.offsetWidth;
      incoming.classList.remove(inClass);
      incoming.classList.add('is-active');
      outgoing.classList.remove('is-active', 'is-prev', 'is-next');
      outgoing.classList.add(outClass);

      // Runs exactly once per step: whichever of transitionend / the timeout
      // fallback comes first wins. Without the guard, a late second call
      // could hide a message that a newer step() had already made active,
      // leaving the bar blank. transitionend bubbles (from links inside the
      // message, and fires once per transitioned property), so only the
      // incoming message's own event counts.
      let finished = false;
      const onTransitionEnd = (event) => {
        if (event.target === incoming) finish();
      };
      const finish = () => {
        if (finished) return;
        finished = true;
        clearTimeout(fallback);
        incoming.removeEventListener('transitionend', onTransitionEnd);
        outgoing.classList.remove('is-prev', 'is-next');
        if (outgoing !== this.messages[this.index]) outgoing.hidden = true;
        this.animating = false;
      };
      incoming.addEventListener('transitionend', onTransitionEnd);
      const fallback = setTimeout(finish, 550);
    }
  }

  if (!customElements.get('announcement-bar')) customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    const dialog = document.getElementById('cart-drawer');
    if (!dialog) return;

    const sectionId = dialog.dataset.sectionId;
    const cartUrl = dialog.dataset.cartUrl;
    const recommendationsBase = dialog.dataset.recommendationsBase;
    const giftWrapProductId = Number(dialog.dataset.giftWrapProductId) || 0;
    const errorEl = dialog.querySelector('[data-cart-drawer-error]');
    const liveEl = dialog.querySelector('[data-cart-drawer-live]');
    // The /cart page is a plain form; once the drawer changes the cart that
    // form is stale, so the page reloads when the drawer closes.
    const onCartPage = !!document.querySelector('[data-cart-page]');
    let cartPageDirty = false;

    // Queue state: key -> target. Keys are:
    // - a line item key (stepper): quantity, sent to /cart/change.js
    // - GIFT_KEY (gift wrap toggle): 1 adds the wrap variant, 0 removes
    //   every wrap line by line key, via /cart/update.js
    // - FIELDS_KEY (gift message / order note): { attributes, note }, via
    //   /cart/update.js
    // Every cart write goes through this single serial queue, so no two
    // writes are ever in flight at once and none can overwrite another.
    const GIFT_KEY = '__gift_wrap__';
    const FIELDS_KEY = '__fields__';
    const targets = new Map();
    let queueRunning = false;
    // Ordering: every request (refresh GET or queue POST) takes a sequence
    // number when it is *sent*. A response is only applied if it was sent
    // after whatever is currently on screen, so a slow older response can
    // never overwrite newer state, whichever code path produced it.
    let requestSeq = 0;
    let appliedSeq = 0;
    // `.is-loading` is driven by a counter of in-flight refreshes (always
    // decremented in `finally`), not by "whoever owns the latest token", so
    // it can never be left on after a refresh gets superseded.
    let loadingCount = 0;
    // A refresh sent while a queue POST is in flight may be answered from
    // cart state that predates that POST, so it can't be trusted: the queue
    // resyncs once more after it drains.
    let resyncAfterQueue = false;
    let announceTimer = null;
    let orphanAttempted = '';
    const REFRESH_TIMEOUT_MS = 15000;

    function routesRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function isGiftWrapItem(item) {
      return !!giftWrapProductId && item.product_id === giftWrapProductId;
    }

    /** Item count without gift wrap lines (wrap is not a bag item). */
    function itemCount(cart) {
      if (!cart || !Array.isArray(cart.items)) return 0;
      return cart.items.reduce((sum, item) => sum + (isGiftWrapItem(item) ? 0 : item.quantity), 0);
    }

    function applyFragment(doc, selector) {
      const fresh = doc.querySelector(selector);
      const live = document.querySelector(selector);
      if (fresh && live) live.replaceWith(fresh);
    }

    function giftToggle() {
      return dialog.querySelector('[data-gift-wrap-toggle]');
    }

    function syncHeaderCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.hidden = count === 0;
      });
      // The notes block is not a swapped fragment (so typing survives a
      // refresh); only its visibility follows the cart.
      const notes = dialog.querySelector('[data-cart-drawer-notes]');
      if (notes) notes.hidden = count === 0;
    }

    function showError(message) {
      if (errorEl) errorEl.textContent = message || dialog.dataset.errorLabel;
    }

    function clearError() {
      if (errorEl) errorEl.textContent = '';
    }

    function captureFocus() {
      const active = document.activeElement;
      if (!active || !dialog.contains(active)) return null;
      if (active.matches('[data-gift-wrap-toggle]')) return { selector: '[data-gift-wrap-toggle]' };
      const stepper = active.closest('[data-qty-increase], [data-qty-decrease]');
      if (!stepper) return null;
      return {
        key: stepper.dataset.lineKey,
        attr: stepper.hasAttribute('data-qty-increase') ? 'data-qty-increase' : 'data-qty-decrease',
      };
    }

    /** The fragment swap replaces the focused control with a fresh copy;
        put focus back on the same control (or the nearest sensible one if
        its line was removed) so keyboard users keep their place. */
    function restoreFocus(saved) {
      if (!saved || !dialog.open) return;
      let target = null;
      if (saved.selector) {
        target = dialog.querySelector(saved.selector);
      } else {
        const escapedKey = window.CSS && CSS.escape ? CSS.escape(saved.key) : saved.key;
        target = dialog.querySelector(`[${saved.attr}][data-line-key="${escapedKey}"]`);
      }
      target =
        target ||
        dialog.querySelector('[data-qty-decrease], [data-qty-increase]') ||
        dialog.querySelector('[data-dialog-close]');
      if (target) target.focus();
    }

    function reapplyPendingTargets() {
      targets.forEach((value, key) => {
        if (key === FIELDS_KEY) return;
        if (key === GIFT_KEY) {
          const toggle = giftToggle();
          if (toggle) {
            toggle.checked = value > 0;
            toggle.disabled = true;
          }
          return;
        }
        const escapedKey = window.CSS && CSS.escape ? CSS.escape(key) : key;
        const line = dialog.querySelector(`[data-cart-line][data-line-key="${escapedKey}"]`);
        const qtyEl = line && line.querySelector('[data-qty-value]');
        if (qtyEl) qtyEl.textContent = value;
        if (line) line.classList.add('is-pending');
      });
    }

    function announce() {
      const source = dialog.querySelector('[data-cart-drawer-live-source]');
      if (!liveEl || !source) return;
      const message = source.textContent.trim();
      // Clear, then set on a later task: setting identical text in the same
      // tick is not a DOM change, so screen readers would skip a repeat total.
      clearTimeout(announceTimer);
      liveEl.textContent = '';
      announceTimer = setTimeout(() => {
        liveEl.textContent = message;
      }, 120);
    }

    /** A cart holding only gift wrap is an empty cart: the server renders
        it as empty and flags the wrap fragment; remove the wrap through the
        queue. Attempted once per set of line keys so a failure can't loop. */
    function removeOrphanGiftWrap() {
      const wrap = dialog.querySelector('[data-cart-drawer-gift-wrap]');
      if (!wrap || !wrap.hasAttribute('data-gift-wrap-orphan')) return;
      const keys = wrap.dataset.giftWrapKeys || '';
      if (!keys || targets.has(GIFT_KEY) || orphanAttempted === keys) return;
      orphanAttempted = keys;
      targets.set(GIFT_KEY, 0);
      runQueue();
    }

    function applySectionHtml(html, options) {
      options = options || {};
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const focus = captureFocus();
      applyFragment(doc, '[data-cart-drawer-shipping]');
      applyFragment(doc, '[data-cart-drawer-items]');
      applyFragment(doc, '[data-cart-drawer-gift-wrap]');
      applyFragment(doc, '[data-cart-drawer-footer]');
      reapplyPendingTargets();
      restoreFocus(focus);
      if (options.announce) announce();
      removeOrphanGiftWrap();
    }

    async function refreshUpsell(cartData) {
      const upsell = document.querySelector('[data-cart-drawer-upsell]');
      if (!upsell) return;
      // Seed from the first real item, never from the gift wrap line.
      const seed = (cartData.items || []).find((item) => !isGiftWrapItem(item));
      if (!seed || !recommendationsBase) {
        upsell.innerHTML = '';
        return;
      }
      try {
        const upsellRes = await fetch(recommendationsBase + '&product_id=' + seed.product_id);
        const upsellHtml = await upsellRes.text();
        const upsellDoc = new DOMParser().parseFromString(upsellHtml, 'text/html');
        applyFragment(upsellDoc, '[data-cart-drawer-upsell]');
      } catch (error) {}
    }

    function setLoading(delta) {
      loadingCount = Math.max(0, loadingCount + delta);
      dialog.classList.toggle('is-loading', loadingCount > 0);
    }

    async function refreshCartDrawer(options) {
      options = options || {};
      const seq = ++requestSeq;
      if (queueRunning) resyncAfterQueue = true;
      setLoading(1);
      const controller = window.AbortController ? new AbortController() : null;
      const timeout = controller ? setTimeout(() => controller.abort(), REFRESH_TIMEOUT_MS) : null;
      const signal = controller ? controller.signal : undefined;

      try {
        const [cartRes, sectionRes] = await Promise.all([
          fetch(routesRoot() + 'cart.js', { headers: { Accept: 'application/json' }, signal: signal }),
          fetch(cartUrl + '?section_id=' + encodeURIComponent(sectionId), { signal: signal }),
        ]);
        if (!cartRes.ok || !sectionRes.ok) throw new Error('cart refresh failed');
        const cartData = await cartRes.json();
        const sectionHtml = await sectionRes.text();

        if (seq > appliedSeq) {
          appliedSeq = seq;
          applySectionHtml(sectionHtml, options);
          syncHeaderCount(itemCount(cartData));
          refreshUpsell(cartData);
        }
      } catch (error) {
        // Leave existing drawer content in place on a network failure/timeout.
      } finally {
        clearTimeout(timeout);
        setLoading(-1);
      }

      if (options.open) window.openDialogAnimated(dialog);
    }

    /** Builds the request for one queue entry, or null when there is
        nothing to send (e.g. removing wrap that is no longer in the cart). */
    function buildRequest(key, value) {
      if (key === FIELDS_KEY) {
        return { path: 'cart/update.js', body: Object.assign({}, value), keepalive: true };
      }
      if (key === GIFT_KEY) {
        const updates = {};
        if (value > 0) {
          const toggle = giftToggle();
          if (toggle && toggle.dataset.variantId) updates[toggle.dataset.variantId] = 1;
        } else {
          // Remove by line key, not variant id: unambiguous even if the
          // wrap variant somehow sits on more than one line.
          const wrap = dialog.querySelector('[data-cart-drawer-gift-wrap]');
          const keys = ((wrap && wrap.dataset.giftWrapKeys) || '').split(',').filter(Boolean);
          keys.forEach((lineKey) => {
            updates[lineKey] = 0;
          });
        }
        if (!Object.keys(updates).length) return null;
        return { path: 'cart/update.js', body: { updates: updates } };
      }
      return { path: 'cart/change.js', body: { id: key, quantity: value } };
    }

    async function postChange(key, value) {
      const request = buildRequest(key, value);
      if (!request) return { ok: true, data: null };
      request.body.sections = [sectionId];
      request.body.sections_url = window.location.pathname;
      const response = await fetch(routesRoot() + request.path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(request.body),
        // Field saves can fire on blur as the shopper navigates away.
        keepalive: !!request.keepalive,
      });
      let data = null;
      try {
        data = await response.json();
      } catch (error) {}
      return { ok: response.ok && !!data, data: data };
    }

    async function runQueue() {
      if (queueRunning) return;
      queueRunning = true;

      let lastCart = null;
      let lastSeq = 0;
      let failed = false;
      let mutated = false;

      while (targets.size > 0) {
        const [key, value] = targets.entries().next().value;
        // Field saves happen while typing; don't dim the drawer for them.
        dialog.classList.toggle('is-updating', key !== FIELDS_KEY);
        let result;
        const seq = ++requestSeq;
        try {
          result = await postChange(key, value);
        } catch (error) {
          result = { ok: false, data: null };
        }

        if (result.ok) {
          if (result.data) {
            lastCart = result.data;
            lastSeq = seq;
            cartPageDirty = true;
          }
          if (key !== FIELDS_KEY) mutated = true;
          // A newer target for this key arrived while the request was in
          // flight: keep the entry so the loop sends the newer target.
          if (targets.get(key) === value) targets.delete(key);
        } else {
          failed = true;
          targets.delete(key);
          if (key === GIFT_KEY) {
            const toggle = giftToggle();
            if (toggle) {
              toggle.checked = !(value > 0);
              toggle.disabled = false;
            }
          }
          const data = result.data || {};
          showError(data.description || data.message);
        }
      }

      queueRunning = false;
      dialog.classList.remove('is-updating');

      const html = lastCart && lastCart.sections && lastCart.sections[sectionId];
      const needsResync = failed || !html || resyncAfterQueue || lastSeq <= appliedSeq;
      resyncAfterQueue = false;
      if (html && !failed && lastSeq > appliedSeq) {
        appliedSeq = lastSeq;
        applySectionHtml(html, { announce: mutated && !needsResync });
        syncHeaderCount(itemCount(lastCart));
        refreshUpsell(lastCart);
      }
      if (needsResync) {
        // A failed or section-less response, or a refresh that overlapped
        // the queue (its answer may predate the final POST): drop any such
        // in-flight refresh and resync once from the server, sent after
        // every POST, so the drawer ends on the cart's real state.
        appliedSeq = requestSeq;
        await refreshCartDrawer({ announce: mutated });
      }
      // Never leave the toggle disabled once nothing is pending for it,
      // even if both the POST and the resync failed.
      const toggle = giftToggle();
      if (toggle && !targets.has(GIFT_KEY)) toggle.disabled = false;
    }

    // Gift message (cart attribute) and order note: staged while typing and
    // queued after a debounce, or immediately on blur. Queued saves merge
    // into one entry, and the queue sends them in order with every other
    // cart write. The fields are also tied to the checkout form
    // (form="CartDrawerCheckout"), so checkout always posts the latest text
    // even if a save is still pending.
    let stagedFields = null;
    let saveTimer = null;
    const SAVE_DELAY_MS = 700;

    function stageField(field) {
      stagedFields = stagedFields || {};
      if (field.hasAttribute('data-cart-note')) {
        stagedFields.note = field.value;
      } else if (field.dataset.cartAttribute) {
        stagedFields.attributes = Object.assign({}, stagedFields.attributes, {
          [field.dataset.cartAttribute]: field.value,
        });
      }
    }

    function flushFields() {
      clearTimeout(saveTimer);
      if (!stagedFields) return;
      const previous = targets.get(FIELDS_KEY) || {};
      const next = Object.assign({}, previous, stagedFields);
      if (previous.attributes || stagedFields.attributes) {
        next.attributes = Object.assign({}, previous.attributes, stagedFields.attributes);
      }
      stagedFields = null;
      // Always a new object, so an in-flight save of the old one is
      // followed by this one (see the identity check in runQueue).
      targets.set(FIELDS_KEY, next);
      runQueue();
    }

    dialog.addEventListener('input', (event) => {
      const field = event.target.closest('[data-cart-attribute], [data-cart-note]');
      if (!field) return;
      stageField(field);
      clearTimeout(saveTimer);
      saveTimer = setTimeout(flushFields, SAVE_DELAY_MS);
    });

    dialog.addEventListener('focusout', (event) => {
      const field = event.target.closest('[data-cart-attribute], [data-cart-note]');
      if (!field) return;
      stageField(field);
      flushFields();
    });

    dialog.addEventListener('change', (event) => {
      const toggle = event.target.closest('[data-gift-wrap-toggle]');
      if (!toggle) return;
      clearError();
      toggle.disabled = true;
      targets.set(GIFT_KEY, toggle.checked ? 1 : 0);
      runQueue();
    });

    if (onCartPage) {
      dialog.addEventListener('close', () => {
        if (cartPageDirty) window.location.reload();
      });
    }

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-dialog-open="cart-drawer"]')) {
        refreshCartDrawer();
        return;
      }

      const incBtn = event.target.closest('[data-qty-increase]');
      const decBtn = event.target.closest('[data-qty-decrease]');
      const bumpBtn = incBtn || decBtn;
      if (!bumpBtn || !dialog.contains(bumpBtn)) return;

      const lineKey = bumpBtn.dataset.lineKey;
      const line = bumpBtn.closest('[data-cart-line]');
      const qtyEl = line && line.querySelector('[data-qty-value]');
      const currentQty = targets.has(lineKey) ? targets.get(lineKey) : parseInt(qtyEl ? qtyEl.textContent : '0', 10) || 0;
      const nextQty = incBtn ? currentQty + 1 : Math.max(0, currentQty - 1);
      if (nextQty === currentQty) return;

      clearError();
      targets.set(lineKey, nextQty);
      if (qtyEl) qtyEl.textContent = nextQty;
      if (line) line.classList.add('is-pending');
      runQueue();
    });

    document.addEventListener('cart:refresh', (event) => {
      clearError();
      // Something outside the drawer (add to cart) changed the cart.
      cartPageDirty = true;
      refreshCartDrawer({ open: !!(event.detail && event.detail.open) });
    });

    // A cart left holding only gift wrap (e.g. from another tab) on load.
    removeOrphanGiftWrap();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    // Gift wrap toggle: submit the whole cart form as an Update so nothing
    // else on the page (quantities, gift message, note) is lost.
    document.addEventListener('change', (event) => {
      const toggle = event.target.closest('[data-cart-page-gift-wrap]');
      if (!toggle || toggle.disabled) return;
      const form = toggle.form || document.getElementById('CartPageForm');
      if (!form) return;

      if (toggle.checked) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'updates[' + toggle.dataset.variantId + ']';
        input.value = '1';
        form.appendChild(input);
      } else {
        // Remove by line key: each wrap line's own quantity input.
        form.querySelectorAll('[data-cart-page-gift-wrap-qty]').forEach((input) => {
          input.value = '0';
        });
      }

      toggle.disabled = true;
      const updateButton = form.querySelector('[data-cart-page-update]');
      if (form.requestSubmit) {
        form.requestSubmit(updateButton || undefined);
      } else if (updateButton) {
        updateButton.click();
      } else {
        form.submit();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  class CollectionView extends HTMLElement {
    connectedCallback() {
      const stored = this.readDensity();
      if (stored) {
        this.dataset.cols = stored;
      }
      this.updateSwatches();

      this.querySelectorAll('[data-cols-btn]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.dataset.cols = button.dataset.colsBtn;
          this.writeDensity(button.dataset.colsBtn);
          this.updateSwatches();
        });
      });

      this.filterToggle = this.querySelector('[data-filter-toggle]');
      this.filterPanel = this.querySelector('[data-filter-panel]');
      this.filterToggle?.addEventListener('click', () => {
        const open = this.filterToggle.getAttribute('aria-expanded') !== 'true';
        this.filterToggle.setAttribute('aria-expanded', String(open));
        this.filterPanel?.classList.toggle('is-open', open);
      });

      // Sort select submits its own GET form (which carries the active
      // filters as hidden inputs) as soon as the choice changes.
      this.querySelectorAll('select[data-auto-submit]').forEach((select) => {
        select.addEventListener('change', () => {
          const form = select.form;
          if (!form) return;
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        });
      });
    }

    // Storage can throw (private mode, blocked site data): the density
    // toggle then simply doesn't persist.
    readDensity() {
      try {
        return window.localStorage.getItem('collection-density');
      } catch (error) {
        return null;
      }
    }

    writeDensity(value) {
      try {
        window.localStorage.setItem('collection-density', value);
      } catch (error) {
        /* not persisted */
      }
    }

    updateSwatches() {
      const cols = Number(this.dataset.cols || 3);
      this.querySelectorAll('[data-cols-btn]').forEach((button) => {
        button.classList.toggle('is-filled', cols >= Number(button.dataset.colsBtn));
      });
    }
  }

  if (!customElements.get('collection-view')) {
    customElements.define('collection-view', CollectionView);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gift-guide')) {
    class GiftGuide extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        if (!this.tabs.length) return;

        this.onClick = (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (tab && this.contains(tab)) this.select(tab, false);
        };

        this.onKeydown = (event) => {
          const current = this.tabs.indexOf(event.target);
          if (current === -1) return;
          let next = null;
          if (event.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === null) return;
          event.preventDefault();
          this.select(this.tabs[next], true);
        };

        this.onBlockSelect = (event) => {
          const tab = this.tabs.find((t) => t.dataset.blockId === event.detail.blockId);
          if (tab) this.select(tab, false);
        };

        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      select(tab, focus) {
        this.tabs.forEach((t) => {
          const selected = t === tab;
          t.setAttribute('aria-selected', selected ? 'true' : 'false');
          t.tabIndex = selected ? 0 : -1;
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
        if (focus) tab.focus();
        tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        const panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel && window.initScrollReveal) window.initScrollReveal(panel);
      }
    }

    customElements.define('gift-guide', GiftGuide);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-dialog-open]');
    if (opener) {
      if (opener.tagName === 'A') event.preventDefault();
      const dialog = document.getElementById(opener.dataset.dialogOpen);
      if (dialog) window.openDialogAnimated(dialog);
      return;
    }

    const closer = event.target.closest('[data-dialog-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (dialog) window.closeDialogAnimated(dialog);
      return;
    }

    if (event.target.tagName === 'DIALOG' && event.target.open) {
      window.closeDialogAnimated(event.target);
    }
  });

  /* Desktop disclosure navigation. Panels open on hover (with a short
     intent delay, pointer devices only) and on the chevron button
     (click / Enter / Space). Escape, focus leaving the item and clicks
     outside close them. A panel opened by click or keyboard stays open
     when the pointer leaves. */
  class HeaderMenu extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-menu-item]'));
      this.timers = new Map();
      this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

      this.items.forEach((item) => {
        const toggle = item.querySelector('[data-menu-toggle]');
        toggle.addEventListener('click', () => {
          if (item.classList.contains('is-open') && item.dataset.openedBy !== 'hover') {
            this.close(item);
          } else {
            this.open(item, 'click');
          }
        });
        item.addEventListener('mouseenter', () => {
          if (!this.hoverQuery.matches) return;
          this.schedule(item, () => this.open(item, 'hover'), 120);
        });
        item.addEventListener('mouseleave', () => {
          if (!this.hoverQuery.matches) return;
          if (item.classList.contains('is-open') && item.dataset.openedBy !== 'hover') {
            this.cancel(item);
            return;
          }
          this.schedule(item, () => this.close(item), 220);
        });
        item.addEventListener('focusout', (event) => {
          if (!item.contains(event.relatedTarget)) this.close(item);
        });
      });

      this.onDocumentClick = (event) => {
        if (!this.contains(event.target)) this.closeAll();
      };
      this.onKeydown = (event) => {
        if (event.key !== 'Escape') return;
        const openItem = this.items.find((item) => item.classList.contains('is-open'));
        if (!openItem) return;
        const hadFocus = openItem.contains(document.activeElement);
        this.close(openItem);
        if (hadFocus) openItem.querySelector('[data-menu-toggle]').focus();
      };
      this.onBlockSelect = (event) => {
        const item = this.items.find((candidate) => candidate.contains(event.target));
        if (item) this.open(item, 'editor');
      };
      this.onBlockDeselect = (event) => {
        const item = this.items.find((candidate) => candidate.contains(event.target));
        if (item) this.close(item);
      };

      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeydown);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      this.timers.forEach((timer) => clearTimeout(timer));
      this.timers.clear();
    }

    schedule(item, callback, delay) {
      this.cancel(item);
      this.timers.set(item, setTimeout(callback, delay));
    }

    cancel(item) {
      clearTimeout(this.timers.get(item));
      this.timers.delete(item);
    }

    open(item, source) {
      this.cancel(item);
      this.items.forEach((other) => {
        if (other !== item) this.close(other);
      });
      item.dataset.openedBy = source;
      item.classList.add('is-open');
      item.querySelector('[data-menu-toggle]').setAttribute('aria-expanded', 'true');
    }

    close(item) {
      this.cancel(item);
      if (!item.classList.contains('is-open')) return;
      delete item.dataset.openedBy;
      item.classList.remove('is-open');
      item.querySelector('[data-menu-toggle]').setAttribute('aria-expanded', 'false');
    }

    closeAll() {
      this.items.forEach((item) => this.close(item));
    }
  }

  if (!customElements.get('header-menu')) customElements.define('header-menu', HeaderMenu);

  // The nav row makes the desktop header height content-dependent, so measure it.
  (() => {
    const header = document.querySelector('.site-header');
    if (!header || !('ResizeObserver' in window)) return;
    new ResizeObserver(() => {
      document.documentElement.style.setProperty('--header-sticky-height', `${header.offsetHeight}px`);
    }).observe(header);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  const PRODUCT_MOBILE_QUERY = '(max-width: 990px)';

  class ProductInfo extends HTMLElement {
    connectedCallback() {
      // The theme editor can detach and re-attach the element; listeners
      // bound to it survive that, so bind once and only re-connect observers.
      if (this.initialized) {
        this.connectStickyBar();
        this.connectEditorEvents();
        return;
      }
      this.initialized = true;

      this.variants = JSON.parse(this.querySelector('[data-product-variants]').textContent);
      const pricesScript = this.querySelector('[data-variant-prices]');
      try {
        this.prices = pricesScript ? JSON.parse(pricesScript.textContent) : {};
      } catch (error) {
        this.prices = {};
      }
      this.selected = {};

      this.querySelectorAll('.product-option').forEach((group) => {
        const index = group.dataset.optionIndex;
        const selectedButton = group.querySelector('.is-selected');
        if (selectedButton) this.selected[index] = selectedButton.dataset.optionValue;
      });

      const input = this.querySelector('[data-variant-id-input]');
      const initialId = input ? Number(input.value) : null;
      this.currentVariant = this.variants.find((variant) => variant.id === initialId) || null;

      this.addButton = this.querySelector('[data-add-to-cart]');
      this.addLabel = this.querySelector('[data-add-to-cart-label]');
      this.errorRegion = this.querySelector('[data-form-error]');

      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-option-value]');
        if (button) {
          event.preventDefault();
          this.selectOption(button);
        }
      });

      const form = this.querySelector('form[action*="/cart/add"]') || this.querySelector('form');
      if (form) {
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.addToCart(form);
        });
      }

      this.initEngraving();
      this.initQuantity();
      this.initStickyBar();
      this.connectEditorEvents();
      // Server and client availability rules differ slightly; let the JS
      // rule (the one used after every selection) decide from the start.
      this.updateOptionAvailability();
    }

    disconnectedCallback() {
      if (this.stickyObserver) this.stickyObserver.disconnect();
      if (this.buttonObserver) this.buttonObserver.disconnect();
      if (this.mediaQuery && this.onMediaChange) this.mediaQuery.removeEventListener('change', this.onMediaChange);
      this.clearLabelTimer();
      this.disconnectEditorEvents();
      document.body.classList.remove('has-sticky-atc');
    }

    /** Theme editor only: open the size guide / reveal the engraving field
        while its block is selected, and close overlays before the section
        is re-rendered or removed. */
    connectEditorEvents() {
      if (!window.Shopify || !window.Shopify.designMode || this.onEditorEvent) return;
      this.onEditorEvent = (event) => {
        const detail = event.detail || {};
        if (detail.sectionId !== this.dataset.sectionId) return;
        const target = event.target;

        if (event.type === 'shopify:section:unload') {
          this.closeOverlays();
          return;
        }
        if (!(target instanceof HTMLElement)) return;

        if (event.type === 'shopify:block:select') {
          if (target.matches('dialog.product-size-guide')) {
            window.openDialogAnimated(target);
          } else if (target.matches('[data-engraving]')) {
            target.scrollIntoView({ block: 'center', behavior: detail.load ? 'instant' : 'smooth' });
          }
        } else if (event.type === 'shopify:block:deselect' && target.matches('dialog.product-size-guide')) {
          window.closeDialogAnimated(target);
        }
      };
      ['shopify:block:select', 'shopify:block:deselect', 'shopify:section:unload'].forEach((type) =>
        document.addEventListener(type, this.onEditorEvent)
      );
    }

    disconnectEditorEvents() {
      if (!this.onEditorEvent) return;
      ['shopify:block:select', 'shopify:block:deselect', 'shopify:section:unload'].forEach((type) =>
        document.removeEventListener(type, this.onEditorEvent)
      );
      this.onEditorEvent = null;
    }

    closeOverlays() {
      this.querySelectorAll('dialog[open]').forEach((dialog) => dialog.close());
      this.setStickyVisible(false);
      document.body.classList.remove('has-sticky-atc');
      document.documentElement.style.overflow = '';
    }

    initQuantity() {
      this.quantityInput = this.querySelector('[data-quantity-input]');
      if (!this.quantityInput) return;
      this.quantityMinus = this.querySelector('[data-quantity-step="-1"]');
      this.quantityPlus = this.querySelector('[data-quantity-step="1"]');

      this.querySelectorAll('[data-quantity-step]').forEach((button) => {
        button.addEventListener('click', () => {
          this.setQuantity(this.getQuantity() + Number(button.dataset.quantityStep));
        });
      });
      this.quantityInput.addEventListener('change', () => this.setQuantity(this.getQuantity()));
      this.setQuantity(this.getQuantity());
    }

    quantityMax() {
      const max = Number(this.quantityInput && this.quantityInput.max);
      return max > 0 ? max : Infinity;
    }

    getQuantity() {
      const value = parseInt(this.quantityInput.value, 10);
      return Number.isNaN(value) ? 1 : value;
    }

    setQuantity(value) {
      const input = this.quantityInput;
      if (!input) return;
      const max = this.quantityMax();
      const quantity = Math.min(Math.max(1, value), max);
      input.value = quantity;
      if (this.quantityMinus) this.quantityMinus.disabled = quantity <= 1;
      if (this.quantityPlus) this.quantityPlus.disabled = quantity >= max;
    }

    /** Caps the quantity at the variant's stock when Shopify tracks it and
        overselling is off (the "max" pre-rendered per variant). */
    updateQuantityMax(variant) {
      if (!this.quantityInput) return;
      const price = variant ? this.prices[String(variant.id)] : null;
      const max = price && price.max ? price.max : null;
      if (max) {
        this.quantityInput.max = max;
      } else {
        this.quantityInput.removeAttribute('max');
      }
      this.setQuantity(this.getQuantity());
    }

    clearLabelTimer() {
      if (this.labelTimer) clearTimeout(this.labelTimer);
      this.labelTimer = null;
    }

    initEngraving() {
      const input = this.querySelector('[data-engraving-input]');
      const preview = this.querySelector('[data-engraving-preview]');
      const count = this.querySelector('[data-engraving-count]');
      if (!input) return;
      const update = () => {
        const value = input.value;
        input.setCustomValidity('');
        if (count) count.textContent = value.length;
        if (preview) {
          const empty = value.trim() === '';
          preview.textContent = empty ? preview.dataset.placeholder || '' : value;
          preview.parentElement.classList.toggle('is-empty', empty);
        }
      };
      input.addEventListener('input', update);
      update();
    }

    selectOption(button) {
      this.clearLabelTimer();
      const index = button.dataset.optionIndex;
      const group = button.closest('.product-option');
      this.selected[index] = button.dataset.optionValue;

      group.querySelectorAll('[data-option-value]').forEach((el) => {
        const active = el === button;
        el.classList.toggle('is-selected', active);
        el.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      const label = group.querySelector('[data-option-value-label]');
      if (label) label.textContent = button.dataset.optionValue;

      const match = this.variants.find((variant) =>
        variant.options.every((value, i) => this.selected[i] === undefined || this.selected[i] === value)
      );

      this.updateVariant(match);
      this.updateOptionAvailability();
      this.showError('');
      if (match) {
        this.updateUrl(match);
        this.showVariantMedia(match);
      }
    }

    /** A value is struck through when no available variant combines it with
        the other currently selected values. */
    updateOptionAvailability() {
      this.querySelectorAll('[data-option-value]').forEach((button) => {
        const i = Number(button.dataset.optionIndex);
        const value = button.dataset.optionValue;
        const available = this.variants.some(
          (variant) =>
            variant.available &&
            variant.options[i] === value &&
            variant.options.every((v, j) => j === i || this.selected[j] === undefined || this.selected[j] === v)
        );
        button.classList.toggle('is-unavailable', !available);
        const a11y = button.querySelector('[data-option-a11y]');
        if (a11y) {
          const template = this.dataset.optionSoldOut;
          a11y.textContent = !available && template ? template.replace('[value]', value) : value;
        }
      });
    }

    updateVariant(variant) {
      this.currentVariant = variant || null;
      const input = this.querySelector('[data-variant-id-input]');
      const addButton = this.addButton;
      const label = this.addLabel;
      const availability = this.querySelector('[data-availability]');
      const availabilityText = this.querySelector('[data-availability-text]');

      const priceRow = this.querySelector('.product-price');
      const paymentTerms = this.querySelector('.product-payment-terms');
      const dynamicCheckout = this.querySelector('[data-dynamic-checkout]');
      if (priceRow) priceRow.classList.toggle('is-unavailable', !variant);
      if (paymentTerms) paymentTerms.hidden = !variant;

      if (!variant) {
        if (input) input.value = '';
        if (addButton) addButton.disabled = true;
        if (label) label.textContent = this.dataset.unavailableLabel;
        if (availability) availability.setAttribute('data-sold-out', '');
        if (availabilityText) availabilityText.textContent = this.dataset.unavailableLabel;
        if (dynamicCheckout) dynamicCheckout.hidden = true;
        this.updateQuantityMax(null);
        // No combination exists: hide the stale compare-at price and saving.
        const was = this.querySelector('[data-price-was]');
        const badge = this.querySelector('[data-price-badge]');
        if (was) was.hidden = true;
        if (badge) badge.hidden = true;
        return;
      }

      if (input && input.value !== String(variant.id)) {
        input.value = variant.id;
        // Shopify's payment terms element listens for this to refresh.
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (addButton) addButton.disabled = !variant.available;
      if (dynamicCheckout) dynamicCheckout.hidden = !variant.available;
      this.updateQuantityMax(variant);

      if (label) {
        label.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldOutLabel;
      }

      if (availability) {
        availability.toggleAttribute('data-sold-out', !variant.available);
      }
      if (availabilityText) {
        availabilityText.textContent = variant.available ? this.dataset.inStockText : this.dataset.soldOutLabel;
      }

      this.updatePrice(variant);
    }

    /** Fills the price row and sale badge from strings pre-formatted
        server-side with the shop's money format. */
    updatePrice(variant) {
      const price = this.prices[String(variant.id)];
      if (!price) return;

      const now = this.querySelector('[data-price-now]');
      const was = this.querySelector('[data-price-was]');
      const badge = this.querySelector('[data-price-badge]');
      const stickyPrice = this.querySelector('[data-sticky-price]');

      if (now) now.textContent = price.price;
      if (stickyPrice) stickyPrice.textContent = price.price;
      if (was) {
        was.textContent = price.compare || '';
        was.hidden = !price.compare;
      }
      if (badge) {
        badge.textContent = price.badge || '';
        badge.hidden = !price.badge;
      }

      const progress = this.querySelector('.product-gallery__progress');
      if (progress) progress.classList.toggle('product-gallery__progress--sale', Boolean(price.compare));
    }

    updateUrl(variant) {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (error) {
        // History API unavailable (e.g. sandboxed frame); the form still works.
      }
    }

    showVariantMedia(variant) {
      const mediaId = variant.featured_media && variant.featured_media.id;
      const gallery = this.querySelector('product-gallery');
      if (mediaId && gallery && typeof gallery.showMediaId === 'function') gallery.showMediaId(mediaId);
    }

    showError(message) {
      if (this.errorRegion) this.errorRegion.textContent = message || '';
    }

    cartAddUrl() {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return `${root.endsWith('/') ? root : `${root}/`}cart/add.js`;
    }

    async addToCart(form) {
      const addButton = this.addButton;
      const label = this.addLabel;
      if (!addButton || addButton.disabled) return;
      this.clearLabelTimer();

      // A required engraving of only spaces would pass checkValidity() and
      // then be dropped below, so flag it as invalid explicitly.
      const engraving = this.querySelector('[data-engraving-input]');
      if (engraving) {
        const blank = engraving.required && engraving.value.trim() === '';
        engraving.setCustomValidity(blank ? engraving.dataset.requiredMessage : '');
      }

      // novalidate keeps the browser from blocking submit; check required
      // fields (engraving) explicitly so the native message still shows.
      if (this.quantityInput) this.setQuantity(this.getQuantity());

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const formData = new FormData(form);
      Array.from(formData.keys()).forEach((key) => {
        if (key.startsWith('properties[') && String(formData.get(key)).trim() === '') formData.delete(key);
      });

      addButton.disabled = true;
      this.showError('');

      try {
        const response = await fetch(this.cartAddUrl(), {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        });

        if (response.ok) {
          if (label) label.textContent = this.dataset.addedLabel;
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
          this.labelTimer = setTimeout(() => {
            this.labelTimer = null;
            this.updateVariant(this.currentVariant);
          }, 1800);
          return;
        }

        let message = this.dataset.errorLabel;
        try {
          const data = await response.json();
          if (data && (data.description || data.message)) message = data.description || data.message;
        } catch (parseError) {
          // Non-JSON error body: keep the generic message.
        }
        this.updateVariant(this.currentVariant);
        this.showError(message);
      } catch (error) {
        this.updateVariant(this.currentVariant);
        this.showError(this.dataset.errorLabel);
      }
    }

    /** Mobile/tablet: fixed bottom bar that appears once the main button has
        scrolled above the viewport. It mirrors the main button's state. */
    initStickyBar() {
      this.stickyBar = this.querySelector('[data-sticky-atc]');
      this.stickyButton = this.querySelector('[data-sticky-atc-button]');
      if (!this.stickyBar || !this.stickyButton || !this.addButton) return;

      this.stickyButton.addEventListener('click', () => {
        if (!this.addButton.disabled) this.addButton.click();
      });

      this.syncSticky = () => {
        this.stickyButton.disabled = this.addButton.disabled;
        if (this.addLabel) this.stickyButton.textContent = this.addLabel.textContent.trim();
      };
      this.buttonObserver = new MutationObserver(this.syncSticky);

      this.mediaQuery = window.matchMedia(PRODUCT_MOBILE_QUERY);
      this.mainButtonAbove = false;
      this.onMediaChange = () => this.setStickyVisible(this.mediaQuery.matches && this.mainButtonAbove);

      if ('IntersectionObserver' in window) {
        this.stickyObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            this.mainButtonAbove = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
            this.setStickyVisible(this.mediaQuery.matches && this.mainButtonAbove);
          });
        });
      }

      this.connectStickyBar();
    }

    /** Observers and media listeners: (re)attached on every connect,
        released in disconnectedCallback. */
    connectStickyBar() {
      if (!this.buttonObserver) return;
      this.buttonObserver.observe(this.addButton, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        characterData: true,
        subtree: true,
      });
      this.syncSticky();
      this.mediaQuery.addEventListener('change', this.onMediaChange);
      if (this.stickyObserver) this.stickyObserver.observe(this.addButton);
    }

    setStickyVisible(visible) {
      const bar = this.stickyBar;
      if (!bar || bar.classList.contains('is-visible') === visible) return;

      if (visible) {
        bar.removeAttribute('inert');
        bar.setAttribute('aria-hidden', 'false');
        void bar.offsetHeight;
        bar.classList.add('is-visible');
        document.body.classList.add('has-sticky-atc');
      } else {
        if (bar.contains(document.activeElement)) {
          let target = this.addButton;
          if (!target || target.disabled) {
            target = this.querySelector('.product-info-panel__title');
            if (target && !target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
          }
          if (target) target.focus({ preventScroll: true });
        }
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
        bar.setAttribute('inert', '');
        document.body.classList.remove('has-sticky-atc');
      }
    }
  }

  if (!customElements.get('product-info')) customElements.define('product-info', ProductInfo);

  /** Desktop: thumbnail rail (hover/focus/click to swap), prev/next arrows,
      hover magnify. Mobile/tablet: a native scroll-snap carousel whose
      position drives the counter/pager. Video, external video and 3D media
      load on demand (3D gets Shopify's model viewer UI and AR via Shopify
      XR). Image slides open a full-screen lightbox with click zoom + pan
      (mouse) and pinch zoom + drag pan (touch). */
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        if (this.resizeObserver && this.scroller) this.resizeObserver.observe(this.scroller);
        if (this.mediaQuery && this.onMediaChange) this.mediaQuery.addEventListener('change', this.onMediaChange);
        this.syncMode();
        return;
      }
      this.initialized = true;

      this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.count = this.slides.length;
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.rail = this.querySelector('[data-gallery-rail]');
      this.scroller = this.querySelector('[data-gallery-thumbs]');
      this.railUp = this.querySelector('[data-thumbs-scroll="-1"]');
      this.railDown = this.querySelector('[data-thumbs-scroll="1"]');
      this.currentLabel = this.querySelector('[data-gallery-current]');
      this.track = this.querySelector('[data-gallery-track]');
      this.dots = Array.from(this.querySelectorAll('[data-gallery-dot]'));
      this.progress = this.querySelector('[data-gallery-progress]');
      this.mediaQuery = window.matchMedia(PRODUCT_MOBILE_QUERY);

      this.thumbs.forEach((thumb, i) => {
        thumb.addEventListener('mouseenter', () => this.setIndex(i));
        thumb.addEventListener('focus', () => this.setIndex(i));
      });

      this.addEventListener('click', (event) => this.onClick(event));
      this.addEventListener('keydown', (event) => this.onKeydown(event));

      if (this.rail && this.scroller) {
        this.scroller.addEventListener('scroll', () => this.updateRail(), { passive: true });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.updateRail());
          this.resizeObserver.observe(this.scroller);
        }
        this.updateRail();
        this.revealThumb(this.thumbs[this.index], 'instant');
      }

      if (this.track) {
        this.track.addEventListener('scroll', () => this.onTrackScroll(), { passive: true });
        this.track.addEventListener('pointerdown', (event) => {
          this.trackPointer = { x: event.clientX, y: event.clientY };
        });
      }

      this.onMediaChange = () => this.syncMode();
      this.mediaQuery.addEventListener('change', this.onMediaChange);
      this.syncMode();

      this.initMagnify();
      this.initXR();

      this.lightbox = this.querySelector('[data-lightbox]');
      if (this.lightbox) this.initLightbox();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.mediaQuery && this.onMediaChange) this.mediaQuery.removeEventListener('change', this.onMediaChange);
      // Removed while the lightbox was open: don't leave the page scroll-locked.
      document.documentElement.style.overflow = '';
    }

    isMobile() {
      return this.mediaQuery.matches;
    }

    syncMode() {
      if (!this.track) return;
      if (this.isMobile()) {
        this.track.setAttribute('role', 'region');
        this.track.setAttribute('aria-roledescription', 'carousel');
        this.track.setAttribute('tabindex', '0');
        if (this.track.dataset.carouselLabel) this.track.setAttribute('aria-label', this.track.dataset.carouselLabel);
        this.scrollTrackTo(this.index, 'instant');
      } else {
        this.track.removeAttribute('role');
        this.track.removeAttribute('aria-roledescription');
        this.track.removeAttribute('tabindex');
        this.track.removeAttribute('aria-label');
      }
    }

    onTrackScroll() {
      if (!this.isMobile() || !this.count) return;
      const width = this.track.clientWidth;
      if (!width) return;
      const index = Math.min(this.count - 1, Math.max(0, Math.round(this.track.scrollLeft / width)));
      if (index !== this.index) this.setIndex(index, { fromScroll: true });
    }

    scrollTrackTo(index, behavior) {
      if (!this.track || !this.isMobile()) return;
      const left = index * this.track.clientWidth;
      if (Math.abs(this.track.scrollLeft - left) < 1) return;
      this.track.scrollTo({ left, behavior: behavior || 'smooth' });
    }

    /** True when the pointer travelled horizontally since pointerdown on the
        track, i.e. the click ended a carousel swipe. */
    wasSwipe(event) {
      const start = this.trackPointer;
      this.trackPointer = null;
      return Boolean(start && event.detail > 0 && Math.abs(event.clientX - start.x) > 10);
    }

    onClick(event) {
      if (this.lightbox && this.lightbox.contains(event.target)) return;

      const thumb = event.target.closest('[data-gallery-thumb]');
      if (thumb) {
        event.preventDefault();
        this.setIndex(this.thumbs.indexOf(thumb));
        return;
      }

      const railButton = event.target.closest('[data-thumbs-scroll]');
      if (railButton) {
        this.scrollRail(Number(railButton.dataset.thumbsScroll));
        return;
      }

      const stepButton = event.target.closest('[data-gallery-step]');
      if (stepButton) {
        this.step(Number(stepButton.dataset.galleryStep));
        return;
      }

      const playButton = event.target.closest('[data-deferred-play]');
      if (playButton) {
        if (this.wasSwipe(event)) return;
        this.loadDeferred(playButton.closest('[data-gallery-slide]'));
        return;
      }

      const zoomButton = event.target.closest('[data-gallery-zoom]');
      if (zoomButton && this.lightbox) {
        if (this.wasSwipe(event)) return;
        this.endMagnify();
        this.openLightbox(Number(zoomButton.dataset.galleryZoom), zoomButton);
      }
    }

    onKeydown(event) {
      if (this.lightbox && this.lightbox.contains(event.target)) return;
      if (this.count < 2) return;
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      if (event.target.closest && event.target.closest('model-viewer, video, iframe')) return;
      if (this.isMobile() && event.target !== this.track) return;
      event.preventDefault();
      this.step(event.key === 'ArrowLeft' ? -1 : 1);
    }

    setIndex(i, { scrollThumb = false, fromScroll = false, behavior = 'smooth' } = {}) {
      if (!this.count) return;
      const index = ((i % this.count) + this.count) % this.count;
      const changed = index !== this.index;
      this.index = index;
      this.endMagnify();

      this.thumbs.forEach((thumb) => {
        thumb.classList.remove('is-active');
        thumb.removeAttribute('aria-current');
      });
      this.slides.forEach((slide) => slide.classList.remove('is-active'));
      this.dots.forEach((dot) => dot.classList.remove('is-active'));

      const thumb = this.thumbs[index];
      if (thumb) {
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-current', 'true');
      }
      if (this.slides[index]) this.slides[index].classList.add('is-active');
      if (this.dots[index]) this.dots[index].classList.add('is-active');
      if (this.progress) this.progress.style.width = `${((index + 1) / this.count) * 100}%`;
      if (this.currentLabel) this.currentLabel.textContent = index + 1;
      if (changed) this.pauseMedia(this.slides[index]);

      if (scrollThumb) this.revealThumb(thumb);
      if (!fromScroll) this.scrollTrackTo(index, behavior);
    }

    step(delta) {
      if (this.isMobile()) {
        const target = Math.min(this.count - 1, Math.max(0, this.index + delta));
        this.setIndex(target);
        return;
      }
      this.setIndex(this.index + delta, { scrollThumb: true });
    }

    /** Used by the variant picker to jump to a variant's featured media. */
    showMediaId(mediaId) {
      const index = this.slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
      if (index > -1) this.setIndex(index, { scrollThumb: true });
    }

    revealThumb(thumb, behavior = 'smooth') {
      if (!thumb || !this.scroller || !this.rail.classList.contains('is-scrollable')) return;
      const top = thumb.offsetTop;
      const bottom = top + thumb.offsetHeight;
      const viewTop = this.scroller.scrollTop;
      const viewHeight = this.scroller.clientHeight;

      if (top < viewTop) {
        this.scroller.scrollTo({ top, behavior });
      } else if (bottom > viewTop + viewHeight) {
        this.scroller.scrollTo({ top: bottom - viewHeight, behavior });
      }
    }

    scrollRail(direction) {
      const thumbStep = this.thumbs[1] ? this.thumbs[1].offsetTop - this.thumbs[0].offsetTop : 0;
      const amount = Math.max(this.scroller.clientHeight - thumbStep, thumbStep);
      this.scroller.scrollBy({ top: direction * amount, behavior: 'smooth' });
    }

    updateRail() {
      const scrollable = this.scroller.scrollHeight > this.rail.clientHeight + 1;
      this.rail.classList.toggle('is-scrollable', scrollable);

      const maxScroll = this.scroller.scrollHeight - this.scroller.clientHeight;
      if (this.railUp) this.railUp.disabled = !scrollable || this.scroller.scrollTop <= 1;
      if (this.railDown) this.railDown.disabled = !scrollable || this.scroller.scrollTop >= maxScroll - 1;
    }

    /* ---------- Deferred media (video, external video, 3D) ---------- */

    loadDeferred(slide) {
      if (!slide || slide.dataset.loaded) return;
      const template = slide.querySelector('template[data-deferred-media]');
      const host = slide.querySelector('[data-deferred-host]');
      if (!template || !host) return;

      slide.dataset.loaded = 'true';
      host.appendChild(template.content.cloneNode(true));
      slide.classList.add('is-media-loaded');

      const video = host.querySelector('video');
      if (video) {
        video.play().catch(() => {});
        video.focus({ preventScroll: true });
      }
      const frame = host.querySelector('iframe');
      if (frame) frame.focus({ preventScroll: true });
      const model = host.querySelector('model-viewer');
      if (model) this.setupModelViewerUI(model);
    }

    setupModelViewerUI(model) {
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
      window.Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: (error) => {
            if (error || !window.Shopify.ModelViewerUI) return;
            this.modelViewers = this.modelViewers || new Map();
            const ui = new window.Shopify.ModelViewerUI(model);
            this.modelViewers.set(model, ui);
            if (typeof ui.play === 'function') ui.play();
          },
        },
      ]);
    }

    pauseMedia(exceptSlide) {
      this.slides.forEach((slide) => {
        if (slide === exceptSlide || !slide.dataset.loaded) return;
        slide.querySelectorAll('video').forEach((video) => video.pause());
        slide.querySelectorAll('iframe').forEach((frame) => {
          try {
            if (/youtube/.test(frame.src)) {
              frame.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            } else if (/vimeo/.test(frame.src)) {
              frame.contentWindow.postMessage('{"method":"pause"}', '*');
            }
          } catch (error) {
            // Cross-origin frame not ready yet; nothing to pause.
          }
        });
        if (this.modelViewers) {
          slide.querySelectorAll('model-viewer').forEach((model) => {
            const ui = this.modelViewers.get(model);
            if (ui && typeof ui.pause === 'function') ui.pause();
          });
        }
      });
    }

    initXR() {
      const data = this.querySelector('[data-product-models]');
      if (!data || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
      let models;
      try {
        models = JSON.parse(data.textContent);
      } catch (error) {
        return;
      }
      const setup = () => {
        if (!window.ShopifyXR) {
          document.addEventListener('shopify_xr_initialized', setup, { once: true });
          return;
        }
        window.ShopifyXR.addModels(models);
        window.ShopifyXR.setupXRElements();
      };
      window.Shopify.loadFeatures([{ name: 'shopify-xr', version: '1.0', onLoad: setup }]);
    }

    /* ---------- Desktop hover magnify ---------- */

    initMagnify() {
      if (!this.hasAttribute('data-hover-zoom')) return;
      const main = this.querySelector('.product-gallery__main');
      if (!main) return;
      this.magnifyQuery = window.matchMedia('(min-width: 991px) and (hover: hover)');

      main.addEventListener('pointermove', (event) => {
        if (event.pointerType !== 'mouse' || !this.magnifyQuery.matches) return;
        if (event.target.closest('.product-gallery__arrow')) {
          this.endMagnify();
          return;
        }
        const slide = this.slides[this.index];
        if (!slide || slide.dataset.mediaType !== 'image') return;
        const image = slide.querySelector('.placeholder-media__image');
        if (!image) return;

        if (!image.dataset.magnifySizes) {
          image.dataset.magnifySizes = 'true';
          image.sizes = '(min-width: 991px) 90vw, 100vw';
        }
        const rect = slide.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        const x = Math.min(100, Math.max(0, ((event.clientX - rect.left) / rect.width) * 100));
        const y = Math.min(100, Math.max(0, ((event.clientY - rect.top) / rect.height) * 100));
        image.style.transformOrigin = `${x}% ${y}%`;
        slide.classList.add('is-magnifying');
        this.magnifiedSlide = slide;
      });

      main.addEventListener('pointerleave', () => this.endMagnify());
    }

    endMagnify() {
      if (this.magnifiedSlide) this.magnifiedSlide.classList.remove('is-magnifying');
      this.magnifiedSlide = null;
    }

    /* ---------- Lightbox ---------- */

    initLightbox() {
      this.lightboxSlides = Array.from(this.lightbox.querySelectorAll('[data-lightbox-slide]'));
      this.lightboxLabel = this.lightbox.querySelector('[data-lightbox-current]');
      this.lightboxIndex = 0;
      this.suppressClickUntil = 0;
      this.zoom = { scale: 1, x: 0, y: 0 };
      this.pointers = new Map();

      this.lightbox.addEventListener('click', (event) => {
        // A swipe, pan or pinch must not also register as a click (which
        // would toggle zoom or, over empty space, close the viewer).
        if (Date.now() < this.suppressClickUntil) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        const stepButton = event.target.closest('[data-lightbox-step]');
        if (stepButton) {
          this.lightboxStep(Number(stepButton.dataset.lightboxStep));
          return;
        }

        const image = event.target.closest('.product-lightbox__image');
        if (image) this.toggleZoom(image, event);
      });

      this.lightbox.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        event.stopPropagation();
        this.lightboxStep(event.key === 'ArrowLeft' ? -1 : 1);
      });

      this.lightbox.addEventListener('pointerdown', (event) => this.onLightboxPointerDown(event));
      this.lightbox.addEventListener('pointermove', (event) => this.onLightboxPointerMove(event));
      this.lightbox.addEventListener('pointerup', (event) => this.onLightboxPointerEnd(event));
      this.lightbox.addEventListener('pointercancel', (event) => this.onLightboxPointerEnd(event));

      this.lightbox.addEventListener('close', () => {
        this.resetZoom();
        this.pointers.clear();
        document.documentElement.style.overflow = '';
        const slide = this.lightboxSlides[this.lightboxIndex];
        const galleryIndex = slide ? Number(slide.dataset.galleryIndex) : this.index;
        this.setIndex(galleryIndex, { scrollThumb: true, behavior: 'instant' });

        const zoomButton = this.querySelector(`[data-gallery-zoom="${this.lightboxIndex}"]`) || this.lightboxTrigger;
        if (zoomButton) zoomButton.focus({ preventScroll: true });
      });
    }

    openLightbox(index, trigger) {
      this.lightboxTrigger = trigger;
      this.showLightboxSlide(index);
      document.documentElement.style.overflow = 'hidden';
      window.openDialogAnimated(this.lightbox);
    }

    showLightboxSlide(i) {
      const count = this.lightboxSlides.length;
      if (!count) return;
      const index = ((i % count) + count) % count;
      this.lightboxIndex = index;
      this.resetZoom();

      this.lightboxSlides.forEach((slide) => {
        slide.hidden = true;
      });
      this.lightboxSlides[index].hidden = false;
      if (this.lightboxLabel) this.lightboxLabel.textContent = index + 1;
    }

    lightboxStep(delta) {
      this.showLightboxSlide(this.lightboxIndex + delta);
    }

    activeLightboxImage() {
      const slide = this.lightboxSlides[this.lightboxIndex];
      return slide ? slide.querySelector('.product-lightbox__image') : null;
    }

    pointerDistance() {
      const [a, b] = Array.from(this.pointers.values());
      if (!a || !b) return 0;
      return Math.hypot(a.x - b.x, a.y - b.y);
    }

    onLightboxPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      this.lastPointerType = event.pointerType;
      this.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });

      if (this.pointers.size === 1) {
        this.swipeStart = { x: event.clientX, y: event.clientY };
        this.gestureMoved = false;
        this.panStart = { x: event.clientX, y: event.clientY, tx: this.zoom.x, ty: this.zoom.y };
        return;
      }

      const image = this.activeLightboxImage();
      if (this.pointers.size === 2 && image) {
        this.swipeStart = null;
        if (!this.zoomedImage) this.prepareZoom(image);
        this.pinchStart = { dist: this.pointerDistance() || 1, scale: this.zoom.scale };
        image.classList.add('is-gesturing');
      }
    }

    onLightboxPointerMove(event) {
      if (!this.pointers.has(event.pointerId)) {
        if (event.pointerType === 'mouse' && this.zoomedImage) this.followPointer(event.clientX, event.clientY);
        return;
      }
      this.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });

      if (this.pinchStart && this.pointers.size >= 2) {
        const ratio = this.pointerDistance() / this.pinchStart.dist;
        const scale = Math.min(this.maxScale, Math.max(1, this.pinchStart.scale * ratio));
        this.gestureMoved = true;
        this.setZoom(scale, this.zoom.x, this.zoom.y);
        return;
      }

      if (event.pointerType === 'mouse') {
        if (this.zoomedImage) this.followPointer(event.clientX, event.clientY);
        return;
      }

      if (this.zoomedImage && this.panStart) {
        const dx = event.clientX - this.panStart.x;
        const dy = event.clientY - this.panStart.y;
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) this.gestureMoved = true;
        this.zoomedImage.classList.add('is-gesturing');
        this.setZoom(this.zoom.scale, this.panStart.tx + dx, this.panStart.ty + dy);
      }
    }

    onLightboxPointerEnd(event) {
      const start = this.swipeStart;
      this.pointers.delete(event.pointerId);

      if (this.pinchStart) {
        if (this.pointers.size < 2) {
          this.pinchStart = null;
          this.suppressClickUntil = Date.now() + 400;
          if (this.zoom.scale < 1.05) {
            this.resetZoom();
          } else {
            const rest = this.pointers.values().next().value;
            if (rest) this.panStart = { x: rest.x, y: rest.y, tx: this.zoom.x, ty: this.zoom.y };
          }
        }
        return;
      }

      if (this.pointers.size === 0) {
        if (this.zoomedImage) {
          this.zoomedImage.classList.remove('is-gesturing');
          if (this.gestureMoved) this.suppressClickUntil = Date.now() + 400;
        }
        this.panStart = null;
      }
      this.swipeStart = null;

      if (event.type !== 'pointerup' || !start) return;
      const dx = event.clientX - start.x;
      const dy = event.clientY - start.y;
      // Any real drag (e.g. a short mouse drag that ends over the backdrop)
      // must not register as a click, which would close the viewer.
      if (Math.abs(dx) > 6 || Math.abs(dy) > 6) this.suppressClickUntil = Date.now() + 400;
      if (this.zoomedImage) return;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
        this.suppressClickUntil = Date.now() + 400;
        this.lightboxStep(dx < 0 ? 1 : -1);
      }
    }

    /** Measure the unscaled image and switch it to the 3000px rendition. */
    prepareZoom(image) {
      this.zoomRect = image.getBoundingClientRect();
      const original = Number(image.dataset.width) || 3000;
      const target = Math.min(3000, original);
      this.maxScale = Math.min(4, Math.max(2, target / Math.max(1, this.zoomRect.width)));
      this.zoomedImage = image;
      this.zoom = { scale: 1, x: 0, y: 0 };
      image.classList.add('is-zoomed');
      image.sizes = `${Math.ceil(this.maxScale * 100)}vw`;
    }

    setZoom(scale, x, y) {
      const image = this.zoomedImage;
      const rect = this.zoomRect;
      if (!image || !rect) return;
      const maxX = (rect.width * (scale - 1)) / 2;
      const maxY = (rect.height * (scale - 1)) / 2;
      this.zoom = {
        scale,
        x: Math.min(maxX, Math.max(-maxX, x)),
        y: Math.min(maxY, Math.max(-maxY, y)),
      };
      image.style.transform = `translate3d(${this.zoom.x}px, ${this.zoom.y}px, 0) scale(${scale})`;
    }

    /** Mouse: the zoomed image pans so the point under the cursor stays in view. */
    followPointer(clientX, clientY) {
      const rect = this.zoomRect;
      if (!rect) return;
      const scale = this.zoom.scale;
      this.setZoom(
        scale,
        (rect.left + rect.width / 2 - clientX) * (scale - 1),
        (rect.top + rect.height / 2 - clientY) * (scale - 1)
      );
    }

    toggleZoom(image, event) {
      if (this.zoomedImage) {
        this.resetZoom();
        return;
      }
      this.prepareZoom(image);
      this.zoom.scale = this.lastPointerType === 'mouse' ? this.maxScale : Math.min(this.maxScale, 2.5);
      this.followPointer(event.clientX, event.clientY);
    }

    resetZoom() {
      if (this.zoomedImage) {
        this.zoomedImage.classList.remove('is-zoomed', 'is-gesturing');
        this.zoomedImage.style.transform = '';
      }
      this.zoomedImage = null;
      this.zoomRect = null;
      this.zoom = { scale: 1, x: 0, y: 0 };
      this.pinchStart = null;
      this.panStart = null;
    }
  }

  if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              window.initScrollReveal && window.initScrollReveal(this);
            }
          })
          .catch(() => {});
      };

      new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lumen-video')) {
    class LumenVideo extends HTMLElement {
      connectedCallback() {
        this.playButton = this.querySelector('[data-video-play]');
        this.toggleButton = this.querySelector('[data-video-toggle]');
        this.video = this.querySelector('video');

        if (this.playButton) {
          this.playButton.addEventListener('click', () => this.loadEmbed());
        }

        if (this.toggleButton && this.video) {
          this.toggleButton.addEventListener('click', () => this.togglePlayback());
        }
      }

      loadEmbed() {
        const src = this.dataset.embedSrc;
        if (!src) return;
        const iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.title = this.dataset.title || 'Video';
        iframe.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        this.querySelector('.video-section__poster')?.remove();
        this.playButton.remove();
        this.appendChild(iframe);
        iframe.focus();
      }

      togglePlayback() {
        if (this.video.paused) {
          this.video.play();
          this.toggleButton.setAttribute('aria-pressed', 'false');
        } else {
          this.video.pause();
          this.toggleButton.setAttribute('aria-pressed', 'true');
        }
      }
    }

    customElements.define('lumen-video', LumenVideo);
  }

  } catch(e) { console.error(e); }
})();
})();
